import Vue from 'vue'

import _ from 'lodash'

const focusable = ['input', 'select', 'textarea', 'button']

function focusFirst (element) {
  if (element.tagName && focusable.indexOf(element.tagName.toLowerCase()) >= 0 && element.tabIndex !== -1) {
    element.focus()
    return element
  } else {
    return _.find(element.childNodes, focusFirst)
  }
}

Vue.directive('focus', {
  inserted: function (el, binding) {
    if (binding.value) {
      setTimeout(() => { focusFirst(el) }, 0)
    }
  },
  update (el, binding) {
    if (binding.value && binding.oldValue !== binding.value) {
      setTimeout(() => { focusFirst(el) }, 0)
    }
  }
})
